<template>
  <v-app>
    <v-main
      class="d-flex"
      :class="{
        'align-center': !isMobile,
        'px-12': !isMobile,
        'py-4': !isMobile,
        'py-4': isMobile,
        'px-0': isMobile,
      }"
    >
      <v-container style="max-width: 1100px !important;">
        <router-view />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
// import Signup from './components/Signup.vue';

export default {
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width <= 910;
    },
  },

};
</script>

<style lang="scss">
html,
.v-main,
.v-app,
body {
  background-color: #F6F6F6 !important;
}

.submit-btn:not([disabled]) {
  box-shadow: 0px 4px 27px 8px rgb(255, 213, 60, 0.33);
}
</style>
